module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result06-9b16c04ae19c2f957be0d6e118ca3239.png";